import { render, staticRenderFns } from "./ToolOSS.vue?vue&type=template&id=27ae7855&scoped=true"
import script from "./ToolOSS.vue?vue&type=script&lang=js"
export * from "./ToolOSS.vue?vue&type=script&lang=js"
import style0 from "./ToolOSS.vue?vue&type=style&index=0&id=27ae7855&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae7855",
  null
  
)

export default component.exports